export { default } from "ember-moment/helpers/-base";
